import $ from 'jquery';
import 'what-input';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.$ = $;
window.jQuery = $;
require('foundation-sites');
require("slick-carousel");

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).ready(function(){

$(document).foundation();

var h = window.innerHeight ? window.innerHeight: $(window).height();
const mediaQuery = window.matchMedia('(min-width: 1024px)');

gsap.defaults({ease: "Power4.easeOut"});
gsap.set(".fadeinFast", {y: 0,autoAlpha: 0});
gsap.set(".scrollfadeinRightFast", {x: 50,autoAlpha: 0});
gsap.set(".scrollfadeinLeftFast", {x: -50,autoAlpha: 0});
gsap.set(".scrollfadeinUpFast", {y: 50,autoAlpha: 0});
gsap.set(".scrollfadeinUpMiddle", {y: 50,autoAlpha: 0});
gsap.set(".scrollfadeinDownFast", {y: -50,autoAlpha: 0});
gsap.set(".rollleft", {x: 0,autoAlpha: 1});
gsap.set(".main-menu", {x: 0,autoAlpha: 1,delay:1});

ScrollTrigger.batch(".fadeinFast", {
    interval: 0.2,
    start: 'top bottom',
    //markers: true,
  onEnter: batch => gsap.to(batch, {autoAlpha: 1,duration: 0.5,delay:0, overwrite: true}),
});


ScrollTrigger.batch(".scrollfadeinRightFast", {
  interval: 0.2,
  onEnter: batch => gsap.to(batch, {autoAlpha: 1,duration: 0.5, x: 0, stagger:0.15, overwrite: true}),
});

ScrollTrigger.batch(".scrollfadeinLeftFast", {
  interval: 0.2,
  onEnter: batch => gsap.to(batch, {autoAlpha: 1,duration: 0.5, x: 0, stagger:0.15,overwrite: true}),
});

ScrollTrigger.batch(".scrollfadeinUpFast", {
  interval: 0.2,
    start: 'top bottom',
    //markers: true,
  onEnter: batch => gsap.to(batch, {autoAlpha: 1,duration: 0.5, y: 0,delay:0 ,overwrite: true}),
});

ScrollTrigger.batch(".scrollfadeinDownFast", {
  interval: 0.2,
    start: 'top bottom',
    //markers: true,
  onEnter: batch => gsap.to(batch, {autoAlpha: 1,duration: 0.5, y: 0,delay:0 ,overwrite: true}),
});

ScrollTrigger.batch(".scrollfadeinUpMiddle", {
  interval: 0.2,
    start: 'top bottom',
  onEnter: batch => gsap.to(batch, {autoAlpha: 1,duration: 0.5, y: 0,delay:0.3,overwrite: true}),
});

ScrollTrigger.batch(".rollleft", {
  //  interval: 1,
  onEnter: batch => gsap.to(batch, {autoAlpha: 1,duration: 0.5, x: -1*$(this).width(),delay:0, stagger:0.15,overwrite: true}),
});

$('.main-menu li a[href^="#"]').on('click',function(ev){
    ev.preventDefault();
    if($('#menu-btn-check').prop("checked")){
        $('#menu-btn-check').prop("checked",false);
    }
    //console.log($(this).attr('href'));
    const st = ScrollTrigger.create({ trigger: $(this).attr('href'), start: 'top top' });
    //console.log(st.start);
    $("html,body").animate({scrollTop:st.start - 50},200);
    gsap.to(window, {duration: 1, scrollTo: {y:st.start, offsetY:50}});
    st.kill();
    //gsap.to(window, { duration: 2, scrollTo: {y:$(this).attr('href'), offsetY: 300}});
});

Fancybox.bind('[data-fancybox="gallery"]', {
  infinite: false,
  showClass: 'fancybox-fadeIn',
  hideClass: 'fancybox-fadeOut',
  animated: true,
  Thumbs: {
    autoStart: true,
    Carousel: {
      fill: true,
      center : true,
      center: function () {
        return this.elemDimWidth > this.wrapDimWidth;
      },
      infinite : true,
    },
  },
  Image: {
    zoom: false,
    click: 'next',
    wheel:false,
  },
  Toolbar: {
    display: [
      { id: "close",
        label: "CLOSE",
        class: "fancybox__button--close",
        html:'<svg width="33px" height="33px" viewBox="0 0 33 33" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>close</title><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="close" transform="translate(1.000000, 1.000000)" stroke="#F1E2D1" stroke-width="2.551"><line x1="30.685" y1="30.684" x2="0.001" y2="-3.55271368e-15" id="l_883"></line><line x1="0" y1="30.684" x2="30.684" y2="-3.55271368e-15" id="l_884"></line></g></g></svg>',
        position: "left",
        },
        {
            id: "counter",
            class: "fancybox__counter",
            html: '<span data-fancybox-index=""></span>&nbsp;/&nbsp;<span data-fancybox-count=""></span>',
            position: "right",
        },
    ],
  },
});

});//ready

$(window).on('load',function(){
  $('#loading').addClass('loaded');
  $('.slick-container').slick(
      {
          slidesToShow: 1,
          dots: true,
          arrows:false,
          infinite:true,
          speed:600,
          autoplaySpeed: 4000,
          easing:'easeInOutQuart',
          autoplay: true,
          //pauseOnHover: true,
      }
  );
  $('.slick-second-container').slick(
      {
          slidesToShow: 1,
          dots: true,
          arrows:false,
          infinite:true,
          speed:600,
          easing:'easeInOutQuart',
          autoplay: false,
      }
  );
  $('.slick-third-container').slick(
      {
          slidesToShow: 3,
          dots: false,
          arrows:true,
          infinite:true,
          speed:600,
          easing:'easeInOutQuart',
          autoplay: false,
          responsive: [
            {
              breakpoint: 640, // 399px以下のサイズに適用
              settings: {
                slidesToShow: 1,
              },
            },
          ],
      }
  );
  ScrollTrigger.refresh();
});

window.onload = function() {
  const spinner = document.getElementById('loading');
  spinner.classList.add('loaded');
}

$(window).on('scroll', function(){
  if ($(window).scrollTop() > $(window).width()) {
    $('.menu-btn').addClass('navy');
  }else{
    if($('.menu-btn').hasClass('navy')){
      $('.menu-btn').removeClass('navy');
    }
  }
  if ($(window).scrollTop() > 100) {
    $('.bt-scroll').hide();
  }else{
    $('.bt-scroll').show();
  }
});
